
































import { PropType } from "vue";
import { mapState } from "vuex";
import { PollutantLegend, MapDataType } from "./../types";
import LoadingAnimation from "./LoadingAnimation.vue";

export default {
  components: {
    LoadingAnimation
  },
  props: {
    legend: { type: Object as PropType<PollutantLegend> },
    mapDataType: { type: String as PropType<MapDataType> }
  },
  computed: mapState(["loading"]),
  data() {
    return {
      mapDataTypes: Object(MapDataType)
    };
  },
  methods: {
    toLocaleNumber(n: number) {
      if (n >= 1000) {
        return n.toLocaleString("fi-FI", { useGrouping: true });
      }
      return n;
    }
  }
};
